import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { linkedinAPI } from "../services/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // Redirect to Lead Generation if already logged in
  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      navigate("/candidate-sourcing", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    try {
      setLoading(true);
      const response = await linkedinAPI.saveEmail(email, "");

      // Only proceed with login if success is true
      if (response && response.success === true) {
        // Store email in localStorage
        localStorage.setItem("userEmail", email);
        // Set a token so ProtectedRoute allows access
        localStorage.setItem("accessToken", "email-auth");

        // Navigate to Lead Generation page
        navigate("/candidate-sourcing");
      } else {
        // Show error message from response
        const errorMessage = response?.error || response?.message || "Failed to save email.";
        setError(errorMessage);
      }
    } catch (error) {
      // Handle error response with success: false
      if (error.response?.data?.success === false) {
        const errorMessage = error.response?.data?.error || error.response?.data?.message || "An error occurred. Please try again.";
        setError(errorMessage);
      } else {
        setError(
          error.response?.data?.message ||
            error.message ||
            "An error occurred. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
      }}
    >
      {/* CENTERED CONTENT */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "527px",
          padding: { xs: "24px 16px", sm: "32px" },
          display: "flex",
          flexDirection: "column",
          gap: { xs: "24px", sm: "32px" },
        }}
      >
        {/* Logo */}
        <Box
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img
            src="/SalesAgent.svg"
            alt="Sales Agent"
            style={{ width: "auto", height: "42px", maxWidth: "100%" }}
          />
        </Box>

        {/* Text Section */}
        <Box>
          <Typography 
            variant="h4" 
            fontWeight={700} 
            mb={0.5}
            sx={{ fontSize: { xs: "24px", sm: "32px" } }}
          >
            Sign in.
          </Typography>
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ fontSize: { xs: "13px", sm: "14px" } }}
          >
            Please login to continue to your account.
          </Typography>
        </Box>

        {/* Form Section */}
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            required
          />

          <Button
            type="submit"
            fullWidth
            size="large"
            variant="contained"
            disabled={loading}
            sx={{
              mt: 2,
              py: 1.2,
              fontWeight: 600,
              bgcolor: "#3b82f6",
              "&:hover": { bgcolor: "#2563eb" },
            }}
          >
            {loading ? "Signing in..." : "Sign in"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
